'use client';
import { useEffect, useState } from 'react';
import { useAppStore } from '@/lib/themeStore';

export default function ThemeProvider({ children }: { children: React.ReactNode }) {
  const [mounted, setMounted] = useState(false);

  // Trigger zustand store rehydration from localStorage after mount
  useEffect(() => {
    useAppStore.persist.rehydrate();
    setMounted(true);
  }, []);

  // Apply theme/locale to <html> after mount to avoid hydration mismatch
  const { theme, locale } = useAppStore();

  useEffect(() => {
    if (!mounted) return;
    const root = document.documentElement;
    if (theme === 'light') {
      root.classList.add('light');
    } else {
      root.classList.remove('light');
    }
    root.setAttribute('dir', locale === 'ar' ? 'rtl' : 'ltr');
    root.setAttribute('lang', locale);
  }, [theme, locale, mounted]);

  return <>{children}</>;
}